//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { timestampToISO, isoToTimestamp, formattedDate } from '../utils/index';
export default {
  components: {},
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      statusMap: {
        0: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/098506cd-549e-4ccd-9f44-e6118b67e853.png',
          title: '待执行',
        },
        2: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/0d159fe2-2179-4bef-baaa-59bb5db42cff.png',
          title: '执行中',
        },
        3: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/8768958e-fc9f-4468-a1ba-516f1a0013cf.png',
          title: '已完成',
        },
        4: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/11b40f35-ffea-41d8-bf74-9e0d01ac7ffb.png',
          title: '失败',
        },
        5: {
          img: 'https://cdn.nges.tencent.com/nges_1/31105202/11b40f35-ffea-41d8-bf74-9e0d01ac7ffb.png',
          title: '部分失败',
        },
      },
      tableData: [],
      renderHeader: (h, { column }) => {
        return [
          column.label,
          h(
            'el-tooltip',
            {
              props: {
                placement: 'bottom',
                effect: 'dark',
                // content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
              },
            },
            [
              h(
                'div',
                {
                  // 当前div是为了实现换行，就这换行研究了好久。。。
                  slot: 'content',
                },
                [
                  '待执行：该刷新任务未开始执行',
                  h('br'),
                  '执行中：该刷新任务已经开始，但未完成整个刷新任务',
                  h('br'),
                  '已完成：该刷新任务已执行结束，且刷新成功',
                  h('br'),
                  '部分失败：该刷新任务已经执行结束，但部分数据/配置刷新失败',
                ],
              ),
              h('span', {
                // 问号模块
                class: {
                  'el-icon-question': true,
                },
              }),
            ],
          ),
        ];
      },

      // 加载状态
      loading: false,
      sandboxTypes: [
        { label: 'full', value: ' full' },
        { label: 'partial', value: 'partial' },
        { label: 'development', value: 'development' },
      ],
      sandboxStatus: [
        { label: ' 待执行', value: '0' },
        { label: '执行中', value: '2' },
        { label: '已完成', value: '3' },
        { label: '失败', value: '4' },
        { label: '部分失败', value: '5' },
      ],
      // 搜索表单
      sandBoxSearch: {
        sandbox_name: '',
        sandbox_type: '',
        task_status: '',
        create_time: '',
        update_time: '',
        exec_time: '',
        update_by: '',
      },
      // 新建窗口展示
      createVisible: false,
      // 模型文件部署
      deployVisible: false,
      detailVisible: false,
      cloneVisible: false,
      operateType: '',
      rowMessage: {},
      errMsgVisible: false,
      errMsg: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getList();
    // 'pppp'
    console.log("%c Line:313 🥥 'pppp'", 'color:#2eafb0', 'pppp');
    this.loading = true;
  },
  methods: {
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },

    refresh() {
      this.resetPage();
      this.getList();
    },

    // 获取列表数据
    getList() {
      console.log('%c Line:263 🍺 this.sandBoxSearch)', 'color:#465975', this.sandBoxSearch);
      const params = {};
      if (this.sandBoxSearch.sandbox_name) {
        params.sandbox_name = this.sandBoxSearch.sandbox_name;
      }
      if (this.sandBoxSearch.sandbox_type) {
        params.sandbox_type = this.sandBoxSearch.sandbox_type;
      }
      if (this.sandBoxSearch.task_status) {
        params.task_status = Number(this.sandBoxSearch.task_status);
      }
      if (this.sandBoxSearch.update_by) {
        params.update_by = this.sandBoxSearch.update_by;
      }
      if (this.sandBoxSearch.update_time) {
        // params.update_time = timestampToISO(this.sandBoxSearch.update_time);
        params.update_time_begin = timestampToISO(this.sandBoxSearch.update_time[0]);
        params.update_time_end = timestampToISO(this.sandBoxSearch.update_time[1]);
      }
      if (this.sandBoxSearch.create_time) {
        // params.create_time = timestampToISO(this.sandBoxSearch.create_time);
        params.create_time_begin = timestampToISO(this.sandBoxSearch.create_time[0]);
        params.create_time_end = timestampToISO(this.sandBoxSearch.create_time[1]);
      }
      if (this.sandBoxSearch.exec_time) {
        // params.exec_time = timestampToISO(this.sandBoxSearch.exec_time);
        params.exec_time_begin = timestampToISO(this.sandBoxSearch.exec_time[0]);
        params.exec_time_end = timestampToISO(this.sandBoxSearch.exec_time[1]);
      }
      if (this.sandBoxSearch.create_by) {
        params.create_by = this.sandBoxSearch.create_by;
      }
      return this.$request({
        url: this.$api.getSandboxRefreshHistory,
        data: {
          offset: (this.pageIndex - 1) * this.pageSize,
          limit: this.pageSize,
          ...params,
        },
      }).then((res) => {
        const computedList = res.list.map((item) => ({
          ...item,
          create_time: formattedDate(isoToTimestamp(item.create_time)),
          update_time: [0, 2].includes(item.task_status)
            ? '-'
            : formattedDate(isoToTimestamp(item.update_time)),
          exec_time: formattedDate(isoToTimestamp(item.exec_time)),
        }));
        this.tableData = computedList;
        this.total = Number(res.total_count) || 0;
      });
    },
    // 表单查询
    handleChange: _.debounce(function () {
      this.refresh();
    }, 1000),
    handleReset() {
      this.resetPage();
      this.sandBoxSearch = {
        sandbox_name: '',
        sandbox_type: '',
        task_status: '',
        create_time: '',
        update_time: '',
        update_by: '',
      };
      this.refresh();
    },
    resetPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    },
    // 分页器
    handleSizeChange(value) {
      this.pageIndex = 1;
      this.pageSize = value;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    handleShowError(row) {
      this.errMsgVisible = true;
      this.errMsg = row.err_msg;
    },
  },
};
